<div class="modal-header">
    <h4 class="modal-title">{{ 'utilities_api-token-created' | translate }}</h4>
</div>
<div class="modal-body">
    <p>
        {{ 'utilities_Copy_token_dialog' | translate }}
    </p>
    <div class="alert alert-info text-break">
        {{ token }}
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" type="button" (click)="copy()">
        {{ 'utilities_Copy' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="activeModal.close()">
        {{ 'reporting_CLOSE' | translate }}
    </button>
</div>
